import type { CreateUserForm } from '@/features/team/types/team.types';
import { type Column, type MobileConfig } from '@chikara/ui';
import { t } from '@/i18n';

export const ROLES = {
  ADMIN: 'Admin',
  BASIC: 'Básico'
};

export const TeamMemberStatus = {
  enabled: 'Activo',
  blocked: 'Bloqueado',
  disabled: 'Inactivo',
  pending_approval: 'Pendiente',
  rejected: 'Rechazado',
  invited: 'Pendiente de aceptación',
  in_progress: 'En progreso'
};


export const TEAM_COLUMNS: Column[] = [
  { key: 'email', label: t('team.table.email'), width: '14%' },
  { key: 'fullname', label: t('team.table.name'), width: '16%' },
  { key: 'disposable', label: t('team.table.disposable'), width: '12%', align: 'right' },
  { key: 'monthly_limit', label: t('team.table.spendingLimit'), width: '14%', align: 'right' },
  { key: 'role', label: t('team.table.role'), width: '10%' },
  { key: 'status', label: t('team.table.status'), width: '12%' },
  { key: 'action', label: '', width: '10%' },
];

export const TEAM_MOBILE_CONFIG: MobileConfig = {
  primaryField: 'email',
  secondaryField: 'fullname',
  expandableFields: ['disposable', 'monthly_limit', 'role', 'status', 'action'],
};

export const defaultUserFormValues: CreateUserForm = {
  role: 'BASIC' as const,
  email: '',
  name: '',
  lname: '',
  slname: '',
  monthly_limit: '',
  phone: '',
  origin: { source: 'invitation' },
};
